import { render, staticRenderFns } from "./SimpleFileUpload.vue?vue&type=template&id=2060844e&scoped=true"
import script from "./SimpleFileUpload.vue?vue&type=script&lang=js"
export * from "./SimpleFileUpload.vue?vue&type=script&lang=js"
import style0 from "./SimpleFileUpload.vue?vue&type=style&index=0&id=2060844e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060844e",
  null
  
)

export default component.exports